// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportedFuncCache33;
var wasmImportedFuncCache34;
var wasmImportedFuncCache35;
var wasmImportedFuncCache36;
var wasmImportedFuncCache37;
var wasmImportedFuncCache38;
var wasmImportedFuncCache39;
var wasmImportedFuncCache40;
var wasmImportedFuncCache41;
var wasmImportedFuncCache42;
var wasmImportedFuncCache43;
var wasmImportedFuncCache44;
var wasmImportedFuncCache45;
var wasmImportedFuncCache46;
var wasmImportedFuncCache47;
var wasmImportedFuncCache48;
var wasmImportedFuncCache49;
var wasmImportedFuncCache50;
var wasmImportedFuncCache51;
var wasmImportedFuncCache52;
var wasmImportedFuncCache53;
var wasmImportedFuncCache54;
var wasmImportedFuncCache55;
var wasmImportedFuncCache56;
var wasmImportedFuncCache57;
var wasmImportedFuncCache58;
var wasmImportedFuncCache59;
var wasmImportedFuncCache60;
var wasmImportObjects = {
	20608: function() {
		return {
			"./midi_bg.js": {
				"__wbindgen_number_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache0["sv"](p0i32,p1i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache1["g$"](p0i32);
				},
				"__wbindgen_number_new": function(p0f64) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache2["AH"](p0f64);
				},
				"__wbindgen_cb_drop": function(p0i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache3["WM"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache4["me"](p0i32,p1i32);
				},
				"__wbg_debug_1dccd22b8a8988e1": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache5["eY"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_error_800b8d466653f7ea": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache6["m8"](p0i32);
				},
				"__wbg_error_d539c0f5eafe6a31": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache7["MB"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_info_17d18b9f8eaab7d9": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache8["I8"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_log_f286f3fe4aad906d": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache9["w1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_warn_3d6689f77cb29c86": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache10["A1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_new_693216e109162396": function() {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache11["_f"]();
				},
				"__wbg_stack_0ddaca5d1abfb52f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache12["Ux"](p0i32,p1i32);
				},
				"__wbg_error_09919627ac0992f5": function(p0i32,p1i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache13["yy"](p0i32,p1i32);
				},
				"__wbg_of_547f094e65266406": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache14["ij"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_apply_769e865e14ecdbb0": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache15["kj"](p0i32,p1i32,p2i32);
				},
				"__wbg_call_65af9f665ab6ade5": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache16["CA"](p0i32,p1i32,p2i32);
				},
				"__wbg_call_187e4e7f6f4285fb": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache17["sN"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_call_a51357fb7467f969": function(p0i32,p1i32,p2i32,p3i32,p4i32) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache18["wP"](p0i32,p1i32,p2i32,p3i32,p4i32);
				},
				"__wbg_new_52205195aa880fc2": function(p0i32,p1i32) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache19["C6"](p0i32,p1i32);
				},
				"__wbg_resolve_0107b3a501450ba0": function(p0i32) {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache20["qQ"](p0i32);
				},
				"__wbg_then_18da6e5453572fc8": function(p0i32,p1i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache21["iC"](p0i32,p1i32);
				},
				"__wbg_then_e5489f796341454b": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache22["yp"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache23["d0"](p0i32,p1i32);
				},
				"__wbindgen_closure_wrapper299": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[58872].exports;
					return wasmImportedFuncCache24["ek"](p0i32,p1i32,p2i32);
				}
			}
		};
	},
	76632: function() {
		return {
			"./spectrum_viz_bg.js": {
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache25["me"](p0i32,p1i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache26["g$"](p0i32);
				},
				"__wbg_debug_1dccd22b8a8988e1": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache27["eY"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_error_800b8d466653f7ea": function(p0i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache28["m8"](p0i32);
				},
				"__wbg_error_d539c0f5eafe6a31": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache29["MB"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_info_17d18b9f8eaab7d9": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache30["I8"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_log_f286f3fe4aad906d": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache31["w1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_warn_3d6689f77cb29c86": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache32["A1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_new_693216e109162396": function() {
					if(wasmImportedFuncCache33 === undefined) wasmImportedFuncCache33 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache33["_f"]();
				},
				"__wbg_stack_0ddaca5d1abfb52f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache34 === undefined) wasmImportedFuncCache34 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache34["Ux"](p0i32,p1i32);
				},
				"__wbg_error_09919627ac0992f5": function(p0i32,p1i32) {
					if(wasmImportedFuncCache35 === undefined) wasmImportedFuncCache35 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache35["yy"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache36 === undefined) wasmImportedFuncCache36 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache36["d0"](p0i32,p1i32);
				}
			}
		};
	},
	76632: function() {
		return {
			"./spectrum_viz_bg.js": {
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache37 === undefined) wasmImportedFuncCache37 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache37["me"](p0i32,p1i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache38 === undefined) wasmImportedFuncCache38 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache38["g$"](p0i32);
				},
				"__wbg_debug_1dccd22b8a8988e1": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache39 === undefined) wasmImportedFuncCache39 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache39["eY"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_error_800b8d466653f7ea": function(p0i32) {
					if(wasmImportedFuncCache40 === undefined) wasmImportedFuncCache40 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache40["m8"](p0i32);
				},
				"__wbg_error_d539c0f5eafe6a31": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache41 === undefined) wasmImportedFuncCache41 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache41["MB"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_info_17d18b9f8eaab7d9": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache42 === undefined) wasmImportedFuncCache42 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache42["I8"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_log_f286f3fe4aad906d": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache43 === undefined) wasmImportedFuncCache43 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache43["w1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_warn_3d6689f77cb29c86": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache44 === undefined) wasmImportedFuncCache44 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache44["A1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_new_693216e109162396": function() {
					if(wasmImportedFuncCache45 === undefined) wasmImportedFuncCache45 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache45["_f"]();
				},
				"__wbg_stack_0ddaca5d1abfb52f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache46 === undefined) wasmImportedFuncCache46 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache46["Ux"](p0i32,p1i32);
				},
				"__wbg_error_09919627ac0992f5": function(p0i32,p1i32) {
					if(wasmImportedFuncCache47 === undefined) wasmImportedFuncCache47 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache47["yy"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache48 === undefined) wasmImportedFuncCache48 = __webpack_require__.c[5520].exports;
					return wasmImportedFuncCache48["d0"](p0i32,p1i32);
				}
			}
		};
	},
	30500: function() {
		return {
			"./wav_decoder_bg.js": {
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache49 === undefined) wasmImportedFuncCache49 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache49["me"](p0i32,p1i32);
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache50 === undefined) wasmImportedFuncCache50 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache50["g$"](p0i32);
				},
				"__wbg_debug_1dccd22b8a8988e1": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache51 === undefined) wasmImportedFuncCache51 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache51["eY"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_error_800b8d466653f7ea": function(p0i32) {
					if(wasmImportedFuncCache52 === undefined) wasmImportedFuncCache52 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache52["m8"](p0i32);
				},
				"__wbg_error_d539c0f5eafe6a31": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache53 === undefined) wasmImportedFuncCache53 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache53["MB"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_info_17d18b9f8eaab7d9": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache54 === undefined) wasmImportedFuncCache54 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache54["I8"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_log_f286f3fe4aad906d": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache55 === undefined) wasmImportedFuncCache55 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache55["w1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_warn_3d6689f77cb29c86": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache56 === undefined) wasmImportedFuncCache56 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache56["A1"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_new_693216e109162396": function() {
					if(wasmImportedFuncCache57 === undefined) wasmImportedFuncCache57 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache57["_f"]();
				},
				"__wbg_stack_0ddaca5d1abfb52f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache58 === undefined) wasmImportedFuncCache58 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache58["Ux"](p0i32,p1i32);
				},
				"__wbg_error_09919627ac0992f5": function(p0i32,p1i32) {
					if(wasmImportedFuncCache59 === undefined) wasmImportedFuncCache59 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache59["yy"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache60 === undefined) wasmImportedFuncCache60 = __webpack_require__.c[93128].exports;
					return wasmImportedFuncCache60["d0"](p0i32,p1i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"224": [
		76632
	],
	"364": [
		76632
	],
	"616": [
		30500
	],
	"712": [
		20608
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"224":{"76632":"78bb65d6607bfc1fc1d2"},"364":{"76632":"78bb65d6607bfc1fc1d2"},"616":{"30500":"2b2aaf0ef0d9e6e3bf28"},"712":{"20608":"8b3ebf2e1ee3b7fee671"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};